import {
  Customer,
  CustomerOutstanding,
  CustomerSummary,
  TermsAndConditions,
  WhitelabelAccount,
} from './actions';

// #region CustomerSummary
export interface CustomerSummariesState {
  pending: boolean;
  summaries: CustomerSummary[] | null;
  error?: string;
}

export const defaultCustomerSummariesState: CustomerSummariesState = {
  pending: false,
  summaries: null,
  error: null,
};
// #endregion

// #region Customer
export interface CustomerState {
  pending: boolean;
  customer: Customer | null;
  error?: string;
}

export const defaultCustomerState: CustomerState = {
  pending: false,
  customer: null,
  error: null,
};
// #endregion

// #region CustomerOutstandings
export interface CustomerOutstandingsState {
  pending: boolean;
  outstandings: CustomerOutstanding[] | null;
  error?: string;
}

export const defaultCustomerOutstandingsState: CustomerOutstandingsState = {
  pending: false,
  outstandings: null,
  error: null,
};
// #endregion

// #region WhitelabelAccount
export interface WhitelabelAccountsState {
  pending: boolean;
  accounts: WhitelabelAccount[] | null;
  error?: string;
}

export const defaultWhitelabelAccountsState: WhitelabelAccountsState = {
  pending: false,
  accounts: null,
  error: null,
};
// #endregion

// #region TermsAndConditions
export interface TermsAndConditionsState {
  pending: boolean;
  tncs?: TermsAndConditions;
  error?: string;
}

export const defaultTermsAndConditionsState = {
  pending: false,
  tncs: null,
  error: null,
};

export interface AcceptTermsAndConditionsState {
  pending: boolean;
  error?: string;
}

export const defaultAcceptTermsAndConditionsState = {
  pending: false,
  error: null,
};
// #endregion
